import { GripVertical } from "lucide-react";

export const GridHandle = () => (
    <div className="z-[1] ">
        <GripVertical className="h-6 w-6 rounded-lg text-neutral-900 " />
    </div>
);
